// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import battleMode from "../battleMode";
import bullet from "./bullet";
import {managers, modules} from "../../../engines/gameEngine";
import CSubPlaneMove from "../../../WsSdk/webSocketProtocol/onlineBattleList/CSubPlaneMove";
import comFluency from "../../../engines/components/comFluency";
import SCSubGameSync from "../../../WsSdk/webSocketProtocol/wsInstanceList/SCSubGameSync";

const {ccclass, property} = cc._decorator;

const CONF = [
    {score: 0, level: 1},
    {score: 100, level: 2},
    {score: 1000, level: 3},
    {score: 1e4, level: 4},
    {score: 1e5, level: 5}
]

@ccclass
export default class plane extends cc.Component {

    // LIFE-CYCLE CALLBACKS:
    @property(cc.Sprite)
    spIcon: cc.Sprite = null;
    @property([cc.SpriteFrame])
    spfIcons: cc.SpriteFrame[] = [];
    @property(cc.Label)
    lbMe: cc.Label = null;

    protected onLoad() {
    }

    protected start() {
    }

    private m_game: battleMode = null;
    private m_type: number;
    private m_seat: number;
    private m_userId: string;
    private m_name: string;
    private m_score: number;
    private m_lastPos: cc.Vec2 = null;
    private m_lastUpdateScore: number;
    private m_level: number = 1;
    private m_i: number;
    private m_shopTime: number;

    protected update(dt: number): void {
        this.m_shopTime -= dt;
        this.m_shopTime = Math.max(0, this.m_shopTime);
    }

    addShopTime() {
        this.m_shopTime += 60;
    }

    getShopTime() {
        return this.m_shopTime;
    }

    getSeatI() {
        return this.m_seat;
    }

    bindData(uid: string, seat: number, gameMode: battleMode, icon: number) {
        icon = icon % 2;
        this.m_level = 1;
        this.m_userId = uid;
        this.m_seat = seat;
        this.m_game = gameMode;
        this.m_type = icon;
        this.spIcon.spriteFrame = this.spfIcons[icon];
        this.m_name = '';
        this.m_score = 0;
        this.m_shopTime = 0;
        this.schedule(() => {
            this.onShut();
        }, 0.15 + Math.random() * 0.05);
        //我
        if (this.m_seat == this.m_game.getSeatId()) {
            this.lbMe.string = '我';
            this.node.zIndex = 1;
            this.node.on('touchstart', this.onTouchStart.bind(this));
            this.node.on('touchmove', this.onTouchMove.bind(this));
            this.node.getComponent(comFluency).enabled = true;
            this.schedule(this.onUpdateMePos.bind(this), 0.016);
        } else {
            this.node.zIndex = 0;
            this.lbMe.string = '……';
            this.node.getComponent(comFluency).enabled = false;
        }
    }

    getUid() {
        return this.m_userId;
    }

    getName() {
        return this.m_name;
    }

    setName(name: string) {
        this.m_name = name;
        this.onUpdateView();
    }

    onNetSetScore(score: number) {
        this.m_score = score;
        this.onUpdateLevel();
    }

    addScore(score: number) {
        this.m_score += score;
        this.onUpdateLevel();
    }

    protected onUpdateView() {
        this.lbMe.string = `Lv.${CONF.length == this.m_level ? 'Max' : this.m_level} ${this.m_name}${this.getSeatI() == this.m_game.getSeatId() ? '(我)' : ''}`;
        this.lbMe.node.color = this.getSeatI() == this.m_game.getSeatId() ? cc.Color.WHITE : cc.Color.GRAY;
    }

    protected onUpdateLevel() {
        let lastLevel = this.m_level;
        do {
            let i = this.m_level;
            if (CONF[i]) {
                if (this.m_score >= CONF[i].score) {
                    this.m_level++;
                    continue;
                }
            }
            break;
        } while (true);
        //
        if (lastLevel != this.m_level) {
            this.m_game.addGameRunInfo(`${this.m_name}升到了${this.m_level}级`);
            if (this.getSeatI() == this.m_game.getSeatId()) {
                modules().uiControlModule.showMessageBox('分数达成，恭喜升级！');
            }
        }
        //
        this.onUpdateView();
    }

    onUpdateMePos() {
        if (!this.m_lastPos || this.m_lastPos.x != this.node.x || this.m_lastPos.y != this.node.y) {
            this.sendMePos();
        }
    }

    sendMePos() {
        const x = this.node.x;
        const y = this.node.y;
        // const cMsg = new CSubPlaneMove(x, y);
        // this.m_game.sendGameMessage(cMsg.getPackageBody(this.m_game.gameId));

        const msg = new SCSubGameSync(-1, x, y);
        this.m_game.sendSyncMessage(msg.getPackageBody());
        this.m_lastPos = this.node.getPosition().clone();
    }

    getScore() {
        return this.m_score;
    }

    onMove(x: number, y: number) {
        this.node.x = x;
        this.node.y = y;
    }

    protected onTouchStart(event: cc.Event.EventTouch) {
        console.log('触摸');
    }

    protected onTouchMove(event: cc.Event.EventTouch) {
        let pos = event.getDelta();
        this.node.x += pos.x;
        this.node.y += pos.y;
    }

    protected onShut() {
        const mePos = this.node.getPosition();
        const split = 50;
        let center = 0;
        if (this.m_level % 2 == 0) {
            center = split / 2;
        }
        //商店子弹
        if (this.m_shopTime > 0) {
            for (let i = 0; i < 15; i++) {
                const node = this.m_game.addBullet();
                node.getComponent(bullet).bindData(this.getSeatI(), this.m_game, 2, i);
                node.angle = 10.5 - 1.5 * i;
                node.setPosition(mePos.x - 24 + 4 * i, mePos.y + 80);
            }
        } else {//默认子弹
            for (let i = 0; i < this.m_level; i++) {
                //
                const node = this.m_game.addBullet();
                node.angle = 0;
                node.getComponent(bullet).bindData(this.getSeatI(), this.m_game, this.m_type);
                //
                if (this.m_level % 2 == 0) {
                    let pt = Math.floor(i / 2);
                    if (i % 2 == 0) {
                        node.setPosition(mePos.x - center - pt * split, mePos.y + 80);
                    } else {
                        node.setPosition(mePos.x + center + pt * split, mePos.y + 80);
                    }
                } else {
                    let pt = Math.floor((i + 1) / 2);
                    if (i == 0) {
                        node.setPosition(mePos.x, mePos.y + 80);
                    } else if ((i + 1) % 2 == 0) {
                        node.setPosition(mePos.x - center - pt * split, mePos.y + 80);
                    } else {
                        node.setPosition(mePos.x + center + pt * split, mePos.y + 80);
                    }
                }
            }
        }
    }

}


































